import React from 'react';
import { Box } from '@mui/material';
import {
  Hero,
  WhyUs,
  SavingsCalculator,
  Pricing,
  About,
  Testimonials,
  Team,
  Contact,
} from '../../components/sections';
import { PageSEO, StructuredData } from '../../components/common';
import { SITE_URL } from '../../utils/constants';

const Home = () => {
  return (
    <>
      <PageSEO
        title="ITorama — Property Management Software for Kenyan Landlords | Pegasus PMS"
        description="Automate M-Pesa rent collection, send instant tenant receipts & manage all your rental properties from one dashboard. Free plan for up to 5 units. Trusted by Kenyan landlords."
        canonical={`${SITE_URL}/`}
      />
      <StructuredData />
      <Box>
        <Hero />
        <WhyUs />
        <SavingsCalculator />
        <Pricing />
        <About />
        <Testimonials />
        <Team />
        <Contact />
      </Box>
    </>
  );
};

export default Home;
